module.exports = __webpack_public_path__ + "assets/img/67_316.bbf87374.jpg";